const MATCH_PREDICATE_TYPE_MATCH_ALL = 'MATCH_ALL';
const MATCH_PREDICATE_TYPE_MATCH_ANY = 'MATCH_ANY';

const PREDICATE_PROPERTY_GROUP_TYPE_MESSAGE = 'message';
const PREDICATE_PROPERTY_GROUP_TYPE_ORDER = 'order';
const PREDICATE_PROPERTY_GROUP_TYPE_PEOPLE = 'people';

module.exports = {
    MATCH_PREDICATE_TYPE_MATCH_ALL,
    MATCH_PREDICATE_TYPE_MATCH_ANY,
    PREDICATE_PROPERTY_GROUP_TYPE_MESSAGE,
    PREDICATE_PROPERTY_GROUP_TYPE_ORDER,
    PREDICATE_PROPERTY_GROUP_TYPE_PEOPLE,
}